import { createDecorator } from '../../instantiation/common/instantiation.js';
const IConfigurationService = ( createDecorator('configurationService'));
export { IConfigurationService };
